(() => {
  if (window.location.hostname.toLowerCase() !== 'verdins.eu') return;

  const preferenceKey = 'verdins-preferred-country';
  const checkedKey = 'verdins-country-detected';
  const rememberChoice = (country) => {
    try {
      window.localStorage.setItem(preferenceKey, country);
    } catch (_) {}
  };

  document.addEventListener('click', (event) => {
    const option = event.target.closest('localization-form a[data-value]');
    if (option && option.closest('form')?.querySelector('input[name="country_code"]')) {
      rememberChoice(option.dataset.value);
    }
  }, true);

  try {
    if (window.localStorage.getItem(preferenceKey) || window.sessionStorage.getItem(checkedKey)) return;
    window.sessionStorage.setItem(checkedKey, '1');
  } catch (_) {
    return;
  }

  const country = window.Shopify?.country;
  const root = window.Shopify?.routes?.root;
  if (!country || !root) return;

  const url = root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(country);
  fetch(url, { credentials: 'same-origin' })
    .then((response) => response.ok ? response.json() : null)
    .then((data) => {
      const suggested = data?.suggestions?.find((item) => item.parts?.country?.handle)?.parts.country.handle;
      if (!suggested || suggested === country) return;

      const form = document.getElementById('HeaderCountryForm');
      const input = form?.querySelector('input[name="country_code"]');
      const option = Array.from(form?.querySelectorAll('a[data-value]') || [])
        .find((item) => item.dataset.value === suggested);
      if (!input || !option) return;

      input.value = suggested;
      form.submit();
    })
    .catch(() => {});
})();